import { type ResultOf } from '@graphql-typed-document-node/core'
import React from 'react'
import { useTranslation } from 'react-i18next'

import {
  RichFilterGroupsDisplay,
  type RichFilterGroupsDisplayProps,
} from '~/components/features/RichFilterGroupsDisplay'
import { graphql } from '~/gql'
import { buildSurveyFilterTextGroups, type SurveyFilterGroups } from '~/utils'

const questionFragment = graphql(`
  fragment RichSurveyFilterGroupsDisplay_Question on Question {
    ...BuildSurveyFilterTextGroups_Question
  }
`)

const customerAttributeGroupFragment = graphql(`
  fragment RichSurveyFilterGroupsDisplay_CustomerAttributeGroup on CustomerAttributeGroup {
    ...BuildSurveyFilterTextGroups_CustomerAttributeGroup
  }
`)

const brandGroupFragment = graphql(`
  fragment RichSurveyFilterGroupsDisplay_BrandGroup on BrandGroup {
    ...BuildSurveyFilterTextGroups_BrandGroup
  }
`)

export type RichSurveyFilterGroupsDisplayProps = {
  brandGroups: ResultOf<typeof brandGroupFragment>[]
  customerAttributeGroups: ResultOf<typeof customerAttributeGroupFragment>[]
  'data-testid'?: string
  filterGroups: SurveyFilterGroups
  questions: ResultOf<typeof questionFragment>[]
}

export const RichSurveyFilterGroupsDisplay = ({
  brandGroups,
  customerAttributeGroups,
  'data-testid': dataTestId = 'components-features-rich-survey-filter-groups-display',
  filterGroups,
  questions,
}: RichSurveyFilterGroupsDisplayProps) => {
  const { t } = useTranslation()
  const filterTextGroups = React.useMemo<
    RichFilterGroupsDisplayProps['filterTextGroups']
  >(
    () =>
      buildSurveyFilterTextGroups({
        filterGroups,
        questions,
        customerAttributeGroups,
        brandGroups,
        t,
      }),
    [brandGroups, customerAttributeGroups, filterGroups, questions, t],
  )

  return (
    <RichFilterGroupsDisplay
      data-testid={dataTestId}
      filterTextGroups={filterTextGroups}
    />
  )
}
